import React from 'react';

import { Box, Container, Grid } from '@material-ui/core';

import { Image } from '../components';
import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockContent } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  root: {
    //
  },
}));

type Props = BlockBuilder<BlockContent>;

export const ContentBlock: React.FC<Props> = ({ block, getImageData }) => {
  const { content, align, image, alt } = block;
  const classes = useBlockStyles(useStyles, block);
  const hasImage = !!image;

  return (
    <Box className={classes.boxBlock}>
      <Container className={classes.root}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={9}>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              spacing={4}
              direction={align === 'left' ? 'row-reverse' : 'row'}
            >
              {!!image && (
                <Grid
                  item
                  xs={12}
                  sm={hasImage ? 6 : 12}
                  md={hasImage ? 4 : 12}
                  style={{ width: '100%' }}
                  className={classes.gridShow}
                >
                  <Image
                    getImageData={getImageData}
                    src={image}
                    alt={alt ?? image}
                    options={{
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={12}
                sm={hasImage ? 6 : 12}
                md={hasImage ? 8 : 12}
                style={{ width: '100%' }}
              >
                <Box dangerouslySetInnerHTML={{ __html: content }} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
